import { FC } from "react";
import { Stack } from "@altimateai/lego";
import { DbtJobsGraph } from "./DbtJobsGraph";
import { DbtJobsTable } from "./DbtJobsTable";
import { useQuery } from "@tanstack/react-query";
import { getSnowflakeJobFilters } from "@/helpers/apis";
import {
  getDateByEndOfDayWithoutTimeoffset,
  getDateByStartOfDayWithoutTimeoffset,
} from "@/components/dateRange/utils";
import { useDateFromSearchParams } from "@/helpers/useTimeHooks";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { Typography } from "@altimateai/lego";
import SpacesRedirectionButton from "@/components/spaces/SpacesRedirectionButton";
import { SPACES_TAG_MAPPING } from "@/helpers/spacesConstants";
import { DateRange } from "@/components/dateRange";
import { WorkflowType } from "@/pages/query/types";
import { DbtIcon } from "@assets/icons";
import { GET_DBT_FILTERS, GET_DBT_JOBS_LIST } from "@/pages/query/constants";

export const DbtJobsNew: FC = () => {
  const { startDate, endDate, onUpdate } = useDateFromSearchParams();

  const { data: filters } = useQuery({
    queryKey: [GET_DBT_JOBS_LIST, GET_DBT_FILTERS, startDate, endDate],
    queryFn: () =>
      getSnowflakeJobFilters({
        start_date: getDateByStartOfDayWithoutTimeoffset(startDate).toISOString(),
        end_date: getDateByEndOfDayWithoutTimeoffset(endDate)?.toISOString(),
        workflow_type: WorkflowType.DBT,
      }),
  });

  return (
    <DatatableContextProvider>
      <Stack direction={"column"} className={"al-bg-white al-p-3 al-rounded"}>
        <Stack align={"center"} justify={"between"}>
          <Stack direction={"row"} align={"center"} gap={"md"} className={"al-my-2"}>
            <DbtIcon className={"al-h-4 al-w-4"} />
            <Typography variant={"section-heading"}>Dbt Projects</Typography>
            <SpacesRedirectionButton tag={SPACES_TAG_MAPPING.WORKLOADS} />
          </Stack>
          <Stack direction={"row"} align={"center"}>
            <DateRange
              variant={"inline"}
              startDate={startDate}
              endDate={endDate}
              availableStaticRanges={["Last day", "Last 7 days", "Last 28 days"]}
              onDateRangeSelect={onUpdate}
            />
            <div id={"dbt-filter-container"} />
          </Stack>
        </Stack>
        <Stack direction={"column"} gap={"xl"}>
          <DbtJobsGraph filters={filters} />
          <DbtJobsTable filters={filters} />
        </Stack>
      </Stack>
    </DatatableContextProvider>
  );
};
